<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Salary Components</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item">Employee</li>
          <li class="breadcrumb-item active" aria-current="page">Salary Components</li>
        </ol>
      </nav>
    </div>
    <div class="head-icons ms-2">
      <a
        href="javascript:void(0);"
        class=""
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        data-bs-original-title="Collapse"
        id="collapse-header"
      >
        <i class="ti ti-chevrons-up"></i>
      </a>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <ul class="nav nav-tabs nav-tabs-solid bg-transparent border-bottom mb-3">
    <ng-container *ngFor="let tab of tabs; let i = index">
      <ng-container *appHasPermission="makePermissions(tabs[i], ['view'])">
        <li class="nav-item">
          <button
            [ngClass]="{ 'nav-link': true, active: activeChild === tab }"
            (click)="renderChild(tab)"
          >
            <i class="ti ti-settings me-2"></i>{{ tab }}
          </button>
        </li>
      </ng-container>
    </ng-container>
  </ul>

  <div [ngSwitch]="activeChild">
    <ng-container *ngSwitchCase="tabs[0]">
      <app-standard-earnings
        *appHasPermission="makePermissions(tabs[0], ['view'])"
      ></app-standard-earnings>
    </ng-container>

    <ng-container *ngSwitchCase="tabs[1]">
      <app-custom-earnings
        *appHasPermission="makePermissions(tabs[1], ['view'])"
      ></app-custom-earnings>
    </ng-container>

    <ng-container *ngSwitchCase="tabs[2]">
      <app-statutory-deductions
        *appHasPermission="makePermissions(tabs[2], ['view'])"
      ></app-statutory-deductions>
    </ng-container>

    <ng-container *ngSwitchCase="tabs[3]">
      <app-custom-deductions
        *appHasPermission="makePermissions(tabs[3], ['view'])"
      ></app-custom-deductions>
    </ng-container>

    <ng-container *ngSwitchCase="tabs[4]">
      <app-reimbursements
        *appHasPermission="makePermissions(tabs[4], ['view'])"
      ></app-reimbursements>
    </ng-container>
  </div>
</div>
